import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStores } from "../../../../store/stores.js";
import { __ } from "../../../../utils/i18n.js";
/**
 * Unauthenticated-state hero. Full-bleed gradient + brand overlay texture +
 * the warm yellow tag familiar from V1. Overlay image is served from the
 * plugin's own `public/images/` folder so there's no runtime dependency on
 * devowl.io.
 */ const UnauthHero = ()=>{
    const { optionStore } = useStores();
    const style = {
        "--rc-account-v2-hero-overlay-url": `url("${optionStore.publicUrl}images/bg-overlay-01.webp")`
    };
    return /*#__PURE__*/ _jsx("section", {
        className: "rc-account-v2-unauth-hero",
        style: style,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-unauth-hero__inner",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "rc-account-v2-unauth-hero__title",
                    children: __("Customer Center")
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "rc-account-v2-unauth-hero__tag",
                    children: __("manage products, subscriptions and licenses")
                })
            ]
        })
    });
};
export { UnauthHero };
